import React, { CSSProperties, FC, PropsWithChildren, useContext } from 'react';

import { Skeleton } from '../../common';
import { PaginationContext } from '../PaginationContext';

import './PaginationContent.scoped.scss';

interface Props {
  loading: boolean;
  variant?: 'default' | 'documents';
  skeletonItemsCount?: number;
  skeletonMinHeight?: string;
  skeletonItemHeight?: string;
}

const SKELETON_ITEMS_COUNT = 10;
const DOCUMENTS_SKELETON_ITEMS_COUNT = 5;
const DOCUMENTS_SKELETON_MIN_HEIGHT = '24rem';
const DOCUMENTS_SKELETON_ITEM_HEIGHT = '4.25rem';

export const PaginationContent: FC<PropsWithChildren<Props>> = ({
  loading,
  variant = 'default',
  skeletonItemsCount,
  skeletonMinHeight,
  skeletonItemHeight,
  children,
}) => {
  const context = useContext(PaginationContext);
  const isInitializing = context.perPage === 0;
  const resolvedSkeletonMinHeight =
    skeletonMinHeight ?? (variant === 'documents' ? DOCUMENTS_SKELETON_MIN_HEIGHT : undefined);
  const resolvedSkeletonItemHeight =
    skeletonItemHeight ?? (variant === 'documents' ? DOCUMENTS_SKELETON_ITEM_HEIGHT : undefined);
  const finalSkeletonItemsCount =
    variant === 'documents'
      ? (skeletonItemsCount ?? DOCUMENTS_SKELETON_ITEMS_COUNT)
      : (skeletonItemsCount ?? SKELETON_ITEMS_COUNT);

  const loadingStyle: CSSProperties = resolvedSkeletonMinHeight
    ? { minHeight: resolvedSkeletonMinHeight }
    : {};

  if (loading || isInitializing) {
    return (
      <div
        className="pagination-content pagination-content--loading"
        aria-busy="true"
        aria-live="polite"
        style={loadingStyle}
      >
        {Array.from({ length: finalSkeletonItemsCount }).map((_, index) => (
          <Skeleton
            key={index}
            className="pagination-content__skeleton-item"
            height={resolvedSkeletonItemHeight}
          />
        ))}
      </div>
    );
  }
  return (
    <>
      {context.count !== 0 ? (
        children
      ) : (
        <div className="pagination-content pagination-content--empty">Нет данных</div>
      )}
    </>
  );
};
